import {isNullOrUndefined} from "./commonUtil";
import {getTranslation} from "./translationUtil";

export const ERROR_BAD_REQUEST = 400;
export const ERROR_NOT_ACCEPTABLE = 406;
export const ERROR_NOT_ALLOWED = 405;
export const ERROR_DUPLICATE_DATA= 503;
export const ERROR_TOO_MANY_REQUESTS = 429;

export const ERROR_NOT_ACCEPTABLE_CLIENT_MSG = ": File failed to upload in a timely manner, please try again";
export const ERROR_NOT_ALLOWED_CLIENT_MSG = ": This file type is not supported. Allowed formats are: doc, csv, docx, docm, gif, jpg, mp4, msg, pdf, png, ppt, pptx, rtf, svg, txt, wmv, xls, xlsx, zip.";
export const ERROR_DUPLICATE_DATA_CLIENT_MSG= ": A file already exists with the combination of Media Group, Quarter, and Year";
export const ERROR_TOO_MANY_REQUESTS_CLIENT_MSG = ": A maximum of 50 files are allowed per upload";
export const ERROR_BAD_REQUEST_CONTENT_MSG = ": The file’s type does not match its extension, which may indicate the file was renamed or is improperly formatted. Please ensure the file’s content type aligns with its extension before uploading.";

export const ERROR_TOO_MANY_FILES = "Upload failed. You can't upload more than 50 files at a time. Reduce the number of files and try again.";
export const throwErrorOnNullOrUndefined = <T>(variable: T | undefined | null, name?: string): T => {
    if (isNullOrUndefined(variable)) {
        const message = `${name || "Variable"} is ${variable}`;

        // to avoid react swallowing errors, see https://github.com/facebook/react/issues/6895
        // eslint-disable-next-line
        console.error(message);

        const x = new Error(message);
        // eslint-disable-next-line
        console.error("=============> x.stack: ", x.stack);

        throw new Error(message);
    }
    return variable;
};

export function assertNever(x: never): never {
    throw new Error("Unexpected object: " + x);
}

export const getErrorSpecificClientMessage = (errorNumber: number): string => {
    let errorSpecificMessage = "";

    if (errorNumber === ERROR_NOT_ACCEPTABLE) {
        errorSpecificMessage = getTranslation("upload.upload-timeout", ERROR_NOT_ACCEPTABLE_CLIENT_MSG);
    }
    if (errorNumber === ERROR_NOT_ALLOWED) {
        errorSpecificMessage = getTranslation("upload.file-type-error", ERROR_NOT_ALLOWED_CLIENT_MSG);
    }
    if (errorNumber === ERROR_DUPLICATE_DATA) {
        errorSpecificMessage = getTranslation("upload.file-type-error", ERROR_DUPLICATE_DATA_CLIENT_MSG);
    }
    if (errorNumber === ERROR_TOO_MANY_REQUESTS) {
        errorSpecificMessage = getTranslation("upload.rate-error", ERROR_TOO_MANY_REQUESTS_CLIENT_MSG);
    }
    if (errorNumber === ERROR_BAD_REQUEST) {
        errorSpecificMessage = getTranslation("upload.bad-request-content", ERROR_BAD_REQUEST_CONTENT_MSG);
    }
    return errorSpecificMessage;
};
